import CardRow from '@/scripts/Components/Row/CardRow';
import ShareBanner from '@/scripts/Components/Molecules/ShareBanner';
import urlLocationHelper from '@/scripts/helpers/url-location-helper';

const VSChannels = function VSChannels() {};
VSChannels.prototype.init = function init() {
  return {
    props: {
      channel: {
        type: Object,
        required: true,
      },
      channelEdition: {
        type: Object,
        required: true,
      },
      channelEditionPlaylists: {
        type: Array,
        required: true,
      },
      isChannelPage: {
        type: Boolean,
        required: true,
      },
    },
    components: {
      CardRow,
      ShareBanner,
    },

    methods: {
      transformFn(playlist) {
        const queries = {
          channel: this.channel.slug,
        };

        queries.edition = this.channelEdition.slug;
        queries.playlist = playlist.info.slug;

        const queryString = urlLocationHelper.query.encode(queries);

        return ({
          url(url) {
            return url + queryString;
          },
        });
      },
    },
  };
};

export default new VSChannels();
